import { KRAJ } from '../../kraj';
import i18n from '../../i18n';

// Jedno miejsce na formatowanie liczb (pl-PL). Front NICZEGO nie liczy — tylko
// formatuje wartości gotowe z API.
const nf0 = new Intl.NumberFormat(KRAJ.locale, { maximumFractionDigits: 0 });
const nf2 = new Intl.NumberFormat(KRAJ.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const isNum = (v) => v !== null && v !== undefined && v !== '' && !Number.isNaN(Number(v));

// Brak wartości: „brak” po polsku, w innym języku ze słownika `asystent`.
const brak = () => i18n.t('asystent:format.brak');

// Kwota w zł (bez miejsc po przecinku). null/undefined -> 'brak'.
//
// TWARDA SPACJA ( ) przed „zł", nie zwykła: przy wąskiej kolumnie przeglądarka
// łamała wiersz dokładnie w tym miejscu i waluta spadała pod kwotę („6506" / „zł").
// Naprawa w formatterze, a nie klasą `whitespace-nowrap` na kilkunastu wywołaniach —
// inaczej pierwszy nowy widok znowu by się zawijał.
// Nazwa historyczna: waluta pochodzi z kraju wersji serwisu (zł albo lei).
export const pln = (v) => (isNum(v) ? `${nf0.format(Math.round(Number(v)))} ${KRAJ.symbol}` : brak());

// Liczba z dwoma miejscami (np. kWp, kWh). null -> 'brak'.
export const dec2 = (v) => (isNum(v) ? nf2.format(Number(v)) : brak());

// Liczba całkowita / lekka (np. sztuki). null -> 'brak'.
export const int = (v) => (isNum(v) ? nf0.format(Number(v)) : brak());

// Odmiana rzeczowników po liczbie (1 / 2-4 / 5+).
export const plural = (n, one, few, many) => {
  const abs = Math.abs(Number(n));
  if (abs === 1) return one;
  const d10 = abs % 10;
  const d100 = abs % 100;
  if (d10 >= 2 && d10 <= 4 && !(d100 >= 12 && d100 <= 14)) return few;
  return many;
};
